import { render, staticRenderFns } from "./UploadFilesForm.vue?vue&type=template&id=b0268712&lang=pug"
import script from "./UploadFilesForm.vue?vue&type=script&lang=js"
export * from "./UploadFilesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
